<div class="container">
  <app-header-actions [headerTitle]="'ARCHIVES.TITLE'" [headerIcon]="faFolder" [config]="headerConfig"
    [initialFilters]="currentFilters" [count]="totalItems + ' ' + ('ARCHIVES.TITLE' | translate)"
    [showCount]="true" (addClick)="onAddArchive()" (filtersChanged)="onFiltersChanged($event)"
    (searchCleared)="onSearchCleared()" (tagFilterCleared)="onTagFilterCleared()"
    (allFiltersCleared)="onAllFiltersCleared()">
  </app-header-actions>

  <app-item-list [items]="archivesAsListItems" [loading]="loading" [config]="listConfig"
    [hasActiveFilters]="hasActiveFilters" (itemClick)="onItemClick($event)" (actionClick)="onActionClick($event)"
    (tagClick)="tagManager.openTagDescription($event)">
  </app-item-list>

  <app-pagination [currentPage]="currentPage" [totalPages]="totalPages" [totalItems]="totalItems" [pageSize]="pageSize"
    (pageChange)="onPageChange($event)"></app-pagination>

  <app-modal-upload-archives [show]="showUploadModal" (close)="closeUploadModal()" (uploadSuccess)="onUploadSuccess()">
  </app-modal-upload-archives>

  <app-modal-delete-confirm [show]="showDeleteModal" [configKey]="archiveToDelete?.name || ''"
    [configType]="'ARCHIVES.TITLE' | translate" (close)="onDeleteClose()"
    (confirm)="onDeleteConfirm()"></app-modal-delete-confirm>

  @if (showPreviewModal) {
  <div class="preview-overlay" (click)="closePreviewModal()">
    <div class="preview-modal" (click)="$event.stopPropagation()">
      <div class="preview-header">
        <h3>{{ currentPreviewArchive?.name }}</h3>
        <button class="close-btn" (click)="closePreviewModal()">
          <fa-icon [icon]="faTimes"></fa-icon>
        </button>
      </div>
      <div class="preview-content">
        @if (previewLoading) {
        <div class="preview-loading">
          <div class="spinner"></div>
          <p>{{ 'ARCHIVES.PREVIEW.LOADING' | translate }}</p>
        </div>
        }
        @if (!previewLoading && isJsonPreview) {
        <app-code-viewer [content]="jsonPreviewContent" language="json"></app-code-viewer>
        }
        @if (!previewLoading && !isJsonPreview && previewPages.length > 0) {
        <app-viewer [images]="previewPages" [numOfPages]="previewMetadata?.totalPages || previewPages.length"
          [imgIndex]="0" [loading]="previewBatchLoading" (changeImgIndex)="onPreviewPageChange($event)">
        </app-viewer>
        }
        @if (!previewLoading && !isJsonPreview && previewPages.length === 0) {
        <div class="preview-error">
          <p>{{ 'ARCHIVES.PREVIEW.NO_PREVIEW' | translate }}</p>
        </div>
        }
      </div>
    </div>
  </div>
  }

  <app-tag-manager #tagManager entityType="archives" [entityName]="'ARCHIVES.TITLE' | translate" [maxTags]="3"
    (tagChanged)="onTagChanged()">
  </app-tag-manager>

  <app-modal-deploy-knowledge-base [show]="showDeployKbModal" [archive]="selectedArchiveForKb"
    (close)="showDeployKbModal = false" (deployed)="showDeployKbModal = false">
  </app-modal-deploy-knowledge-base>

  <app-modal-knowledge-base-history [show]="showKbHistoryModal" [archive]="selectedArchiveForKb"
    (close)="showKbHistoryModal = false">
  </app-modal-knowledge-base-history>
</div>
